import dynamic from 'next/dynamic'

const CurrentHarvest = dynamic(() => import('./CurrentHarvest'))

export default CurrentHarvest
